<div #scrolltable [ngClass]="{ hidden: modeView === 'T' }" class="scroll-table">
  <div style="padding: 4px 10px; color: #ffffff; border-bottom: 0 none">
    <i class="pi pi-search" style="margin: 4px 4px 0 0"></i>
  </div>
  <div class="grid">
    <div [ngClass]="{ 'col-12 md:col-6 lg:col-6': modeView === 'S' || modeView === 'D',  'col-12 md:col-12 lg:col-12': modeView !== 'S' && modeView !== 'D'}"
      class="col-12 md:col-6 lg:col-6">
      <p-table
        #dt
        [(selection)]="selectedDocs"
        selectionMode="multiple"
        [columns]="listColumns"
        [value]="resultDisplay"
        [rows]="nbRow"
        [paginator]="true"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        [(first)]="first"
        (onRowSelect)="onRowSelect($event)"
        (onPage)="pageChange($event)"
        styleClass=" p-datatable-striped"
      >
        <ng-template let-columns pTemplate="header">
          <tr>
            <th class="width-col-3">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            @if (hasLock === true) {
              <th class="width-col-3"></th>
            }
            @if (modeView === 'S') {
              <th class="width-col-3">PDF</th>
            }
            @if (modeView === 'D') {
              <th class="width-col-3">{{'Detail_1' | translate}}</th>
            }
            @if (modeView === 'G') {
              <th class="width-col-3">
                <i data-icons8="&#xf150;" pTooltip="{{'Detail_2' | translate}}"></i>
              </th>
            }
            @for (col of columns; track col; let i = $index) {
              <th
                [pSortableColumn]="col.field"
                [ngClass]="{
                  'width-col-4':
                      col.field === 'doc_atfcount' ||
                      col.field === 'bsk_mailurgent' ||
                      col.field === 'bsk_mailconf' ||
                      col.field === 'bsk_delay',
                  'width-col-date': col.type === 'DateTime' && srchMode === reqBsk,
                  'width-col-label': col.field === 'bsk_mailactionLabel' && srchMode === reqBsk,
                  'width-auto':
                      col.field !== 'bsk_mailconf' &&
                      col.field !== 'bsk_mailurgent' &&
                      col.field !== 'bsk_delay' &&
                      col.field !== 'bsk_mailactionLabel'
                  }"
                >
                <p-sortIcon [field]="col.field"></p-sortIcon>
                @if (col.field === 'bsk_mailurgent') {
                  <i class="icons8-haute-priorit- size-ico font-red" pTooltip="{{'&bsk_mailurgent' | translate}}"></i>
                }
                @if (col.field === 'bsk_mailconf') {
                  <i class="icons8-confidentialit--du-courrier size-ico" pTooltip="{{'&bsk_mailconf' | translate}}"></i>
                }
                @if (col.field === 'bsk_delay') {
                  <i class="icons8-clock size-ico" pTooltip="{{'&bsk_delay' | translate}}"></i>
                }
                @if (
                  col.field !== 'bsk_mailurgent' &&
                  col.field !== 'bsk_mailconf' &&
                  col.field !== 'bsk_delay'
                  ) {
                    {{ col.header }}
                  <input
                    (click)="$event.stopPropagation()"
                    pInputText
                    type="text"
                    (input)="dt.filter($event.target.value, col.field, 'contains')"
                    style="color: darkgrey"
                  />
                }
              </th>
            }
          </tr>
        </ng-template>
        <ng-template let-rowData let-rowIndex="rowIndex" let-columns="columns" pTemplate="body">
          <tr
            [pSelectableRow]="rowData"
            class="table-row"
            [ngClass]="{ 'back-color': rowData.doc_docid === splitId && (modeView === 'S' || modeView === 'D')}"
            (mouseover)="changeImage(rowData.url800, rowData.doc_docid)"
            >
            <td (click)="clickcolck($event)">
              <p-tableCheckbox [value]="rowData" [index]="rowIndex"></p-tableCheckbox>
            </td>
            @if (hasLock === true) {
              <td>
                @if (rowData.doc_checkoutuser !== '') {
                  @if (rowData.doc_checkoutuser !== currentUser) {
                    <i class="lock-icon-red" data-icons8="&#xf12e;"></i>
                  }@else {
                    <i
                      class="lock-icon-green"
                      data-icons8="&#xf12e;"
                    ></i>
                  }
                }@else {
                  <span></span>
                }
              </td>
            }
            @if (modeView === 'S') {
              <td (click)="clickcolpdf($event, rowData.doc_docid)">
                <i data-icons8="&#xf110;"></i>
              </td>
            }
            @if (modeView === 'D') {
              <td (click)="clickcolpdf($event, rowData.doc_docid)">
                <i data-icons8="&#xf150;"></i>
              </td>
            }
            @if (modeView === 'G') {
              <td (mouseenter)="showImage(rowData.url800, rowData.doc_docid)" (mouseleave)="clearTime()">
                <i data-icons8="&#xf150;"></i>
              </td>
            }
            @for (col of columns; track col; let i = $index) {
              <td class="width-auto data-column">
                  @switch (col.type) {
                    @case ('DateTime') {
                      <div class="align-left">
                        {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy' }}
                        <!-- {{ rowData[col.field] | datecompat | date: 'dd/MM/yyyy' }} -->
                        @if (rowData[col.field] != '') {
                          <button
                            title="{{ rowData[col.field] }}"
                            type="button"
                            pButton
                            icon="pi pi-clone"
                            class="p-button-raised p-button-secondary right copy-button"
                            (click)="copyvalue($event, rowData[col.field])"
                          ></button>
                        }
                      </div>
                    }
                    @case ('Double') {
                      <div class="align-right">
                        {{ rowData[col.field] }}
                        @if (rowData[col.field] != '') {
                          <button
                            title="{{ rowData[col.field] }}"
                            type="button"
                            pButton
                            icon="pi pi-clone"
                            class="p-button-raised p-button-secondary right copy-button"
                            (click)="copyvalue($event, rowData[col.field])"
                          ></button>
                        }
                      </div>
                    }
                    @case ('Boolean') {
                      <div class="align">
                        @if (col.field === 'bsk_mailurgent') {
                          @if (rowData[col.field] === '1') {
                            <i class="icons8-haute-priorit- size-ico font-red"></i>
                          }
                        }
                        @if (col.field === 'bsk_mailconf') {
                          @if (rowData[col.field] === '1') {
                            <i class="icons8-confidentialit--du-courrier size-ico"></i>
                          }
                        }
                        @if (col.field !== 'bsk_mailurgent' && col.field !== 'bsk_mailconf') {
                          {{ rowData[col.field] }}
                          @if (rowData[col.field] !== '') {
                            <button
                              title="{{ rowData[col.field] }}"
                              type="button"
                              pButton
                              icon="pi pi-clone"
                              class="p-button-raised p-button-secondary right copy-button"
                              (click)="copyvalue($event, rowData[col.field])"
                            ></button>
                          }
                        }
                      </div>
                    }
                    @default {
                      @if (col.field === 'bsk_mailactionLabel') {
                        <div
                          class="badge" [ngClass]="{
                            grey: rowData['bsk_mailaction'] === '0',
                            green: rowData['bsk_mailaction'] === '1',
                            orange: rowData['bsk_mailaction'] === '2',
                            purple: rowData['bsk_mailaction'] === '3',
                            blue: rowData['bsk_mailaction'] === '4'
                          }"
                          >
                          {{rowData['bsk_mailactionLabel']}}
                        </div>
                      }
                      @if (col.field === 'bsk_delay') {
                        @if (rowData[col.field] === 1) {
                          <i class="icons8-clock size-ico"></i>
                        }
                        @if (rowData[col.field] === 2) {
                          <i class="icons8-clock size-ico clock-green"></i>
                        }
                        @if (rowData[col.field] === 3) {
                          <i class="icons8-clock size-ico clock-yellow"></i>
                        }
                        @if (rowData[col.field] === 4) {
                          <i class="icons8-clock size-ico clock-red"></i>
                        }
                      }
                      @if (col.field === 'doc_atfcount' && rowData[col.field] !== '0') {
                        {{ rowData[col.field] }}
                        @if (rowData[col.field] !== '') {
                          <button
                            title="{{ rowData[col.field] }}"
                            type="button"
                            pButton
                            icon="pi pi-clone"
                            class="p-button-raised p-button-secondary right copy-button"
                            (click)="copyvalue($event, rowData[col.field])"
                          ></button>
                        }
                      }
                      @if (col.field !== 'doc_atfcount' && col.field !== 'bsk_delay' && col.field !== 'bsk_mailactionLabel') {
                        {{ rowData[col.field] }}
                        @if (rowData[col.field] !== '') {
                          <button
                            title="{{ rowData[col.field] }}"
                            type="button"
                            pButton                           
                            icon="pi pi-clone"
                            class="p-button-raised p-button-secondary right copy-button"
                            (click)="copyvalue($event, rowData[col.field])"
                          ></button>
                        }
                      }
                    }
                  }
              </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">{{'Empty' | translate}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    @if (pathPdf && modeView === 'S') {
      <div class="col-12 md:col-6 lg:col-6">
        <div class="col-12 max-pdfsplit">
          <pdf-preview [pathPdf]="pathPdf" style="position: relative"></pdf-preview>
        </div>
      </div>
    }
    @if (modeView === 'D') {
      <div class="col-12 md:col-6 lg:col-6">
        <div class="col-12">
          <documentdetailgrid 
            [originClick]="originClick"
            [editMode]=false
            [paramDetail]="paramDetail"
            [tabview]="modeDetail"
            [pathPdf]="pathPdf"
            >
          </documentdetailgrid>
        </div>
      </div>
    }
  </div>
</div>
<p-dialog [style]="{ margin: 0}" [(visible)]="showThumb" (onHide)="hideImage()" position="top-right" closable="true" showHeader="true">
  <img
    class="cursorPointer"
    [src]="thumbs"
    (click)="clickImg()"
    />
</p-dialog>
